import React, { useState } from 'react';
import { Tabs } from 'antd';
import TablePage from '../../../../../components/pages/TablePage';
import Awbs from './awbs';
import { TransferHorizontalIcon } from "@solar-icons/react/outline/transfer-horizontal";
import PageScan from './scan';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { message, Spin } from 'antd';
import { PostAPI } from '../../../../../redux';

const { TabPane } = Tabs;

const ImportInTabs = () => {

    const dispatch = useDispatch();
    const [refresh, setRefresh] = useState(moment().unix());
    const [sendingRowId, setSendingRowId] = useState(null);

    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const handleSendAll = async (row) => {
        if (sendingRowId) {
            return;
        }

        const currentRowId = row?._id ?? row?.flight_number ?? 'send-all';
        setSendingRowId(currentRowId);

        if (!Array.isArray(row?.awbs) || row.awbs.length === 0) {
            setSendingRowId(null);
            return;
        }

        const validAwbs = row.awbs.filter(a => a.import_in_params !== undefined && a.import_in_params !== null);
        if (validAwbs.length === 0) {
            setSendingRowId(null);
            return;
        }

        const invalid = validAwbs?.find(awb =>
            !awb.kode_kemas ||
            !awb.no_pos_bc11 ||
            !awb.exportir_name
        );

        if (invalid) {
            message.error('Semua AWB harus memiliki Kode Kemas, No Pos BC11, dan Nama Eksportir yang diisi.');
            setSendingRowId(null);
            return;
        }

        const updatedAwbs = validAwbs?.map(({
            _id, exportir_npwp, no_bc11, no_pos_bc11, kode_kemas, tgl_tiba, exportir_name,
            hawb_number, hawb_date, mawb_number, mawb_date,
            bruto, jml_kemas, tgl_bc11
        }) => ({
            _id,
            exportir_npwp,
            no_bc11,
            no_pos_bc11,
            tgl_tiba,
            exportir_name,
            hawb_number,
            mawb_number,
            bruto, jml_kemas,
            wk_inout: moment().format('YYYYMMDDHHmmss'),
            hawb_date: moment(hawb_date).format('YYYYMMDD'),
            mawb_date: moment(mawb_date).format('YYYYMMDD'),
            tgl_bc11: moment(tgl_bc11).format('YYYYMMDD'),
            kode_kemas: kode_kemas.toUpperCase()
        }));

        try {
            for (let idx = 0; idx < updatedAwbs.length; idx += 1) {
                const data = updatedAwbs[idx];

                await dispatch(PostAPI({
                    url: 'api/v1/tps_import/import_in',
                    data: { ...data, wk_inout: moment().format('YYYYMMDDHHmmss') }
                }));

                if (idx < updatedAwbs.length - 1) {
                    await delay(3000);
                }
            }
            setRefresh(moment().unix());
        } catch (error) {
            message.error('Terjadi kesalahan saat mengirim data. Silakan coba lagi.');
        } finally {
            setSendingRowId(null);
        }
    };

    const columns = [
        {
            selector: (row) => row?.flight_number,
            name: "Flight Number"
        },
        {
            selector: (row) => row?.flight_date,
            name: "Flight Date"
        },
        {
            name: "Send All",
            id: '_id',
            selector: (row) => (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: sendingRowId ? 'not-allowed' : 'pointer',
                        pointerEvents: sendingRowId ? 'none' : 'auto'
                    }}
                    onClick={() => handleSendAll(row)}
                >
                    {sendingRowId === (row?._id ?? row?.flight_number ?? 'send-all') ? (
                        <Spin size="small" />
                    ) : (
                        <TransferHorizontalIcon
                            size={20}
                            style={{ color: 'black' }}
                        />
                    )}
                </div>
            )
        },
    ];

    return (
        <Tabs defaultActiveKey="list">
            <TabPane tab="List Data" key="list">
                <TablePage
                    title="Import In"
                    url="api/v1/tps_import_pjt/import_in"
                    actionPosition="right"
                    columns={columns}
                    ExpandComponent={Awbs}
                    refresh={refresh}
                />
            </TabPane>
            <TabPane tab="Scan Gate In" key="scan">
                <PageScan />
            </TabPane>
        </Tabs>
    );
};

export default ImportInTabs;
